import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { defer, Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, startWith } from 'rxjs/operators';
import { Routes } from '@nimbus-portal/features/menu/models/consts/routes.consts';
import { AcTeamDetailsRequestService } from './ac-team-details-request.service';

const ATTENDANT_CONSOLE_URL = Routes.personalAttendantconsole.path!;

@Injectable({ providedIn: 'root' })
export class HeaderBarNavigationService {
  // Emits whether the current route is the Attendant Console. Service-name and pinned-service
  // clicks may only jump into the AC while the agent is already there.
  public readonly isOnAttendantConsole$: Observable<boolean>;

  public constructor(
    private readonly router: Router,
    private readonly acTeamDetailsRequestService: AcTeamDetailsRequestService,
  ) {
    // defer() reads router.url when each consumer subscribes (not when this singleton is created),
    // so a header recreated after a later navigation seeds from the current route, not a stale one.
    this.isOnAttendantConsole$ = defer(() =>
      this.router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map((event) => this.isAttendantConsoleUrl(event.urlAfterRedirects)),
        startWith(this.isAttendantConsoleUrl(this.router.url)),
        distinctUntilChanged(),
      ),
    );
  }

  public openTeamInAttendantConsole(teamId: string): void {
    this.acTeamDetailsRequestService.request(teamId);
    this.router.navigate([ATTENDANT_CONSOLE_URL]).then();
  }

  private isAttendantConsoleUrl(url: string): boolean {
    return url.split('?')[0].startsWith(ATTENDANT_CONSOLE_URL);
  }
}
